<script lang="ts">
  import { onMount } from "svelte";

  import { beginLogin } from "../../lib/auth";
  import { resolveAppConfig } from "../../lib/config";

  let error = $state("");

  onMount(async () => {
    try {
      const cfg = await resolveAppConfig();
      await beginLogin(cfg.oidc, "/account");
    } catch (e) {
      error = e instanceof Error ? e.message : "Sign-in failed";
    }
  });
</script>

<section class="max-w-md mx-auto px-6 py-24 text-center">
  {#if error}
    <p class="text-red-400">{error}</p>
  {:else}
    <p class="text-slate-400">Redirecting to sign-in…</p>
  {/if}
</section>
